import * as yup from 'yup'

export const ValidationSchema = yup.object().shape({
  observations: yup.string().max(80, 'Máximo de 80 caracteres.')
})
